import { Component } from '@angular/core';
import { AbstractWidgetComponent } from '../../shared/abstract-widget.component';
import { WidgetAppImageComponent } from '../../shared/widget-app-image/widget-app-image.component';

@Component({
    selector: 'app-logo-widget',
    templateUrl: './logo-widget.component.html',
    styleUrls: ['./logo-widget.component.scss'],
    imports: [WidgetAppImageComponent]
})
export class LogoWidgetComponent extends AbstractWidgetComponent {
  public url = "https://web.avpark.ch";
  public image = "../../../assets/img/av_park_linear_green4.png";

  public defaultSizeX = 3;
  public defaultSizeY = 2;

  private panelId: string;
  private onDeleteCallback: (panelId: string) => void;

  constructor() {
    super();
  }

  public initializeParameters(panelId: string, serializedParameters: string, onDeleteCallback: (panelId: string) => void) {
    this.panelId = panelId;
    this.onDeleteCallback = onDeleteCallback;
  }

  public onDelete() {
    this.onDeleteCallback(this.panelId);
  }
}
